import { render, staticRenderFns } from "./AtDataTable.vue?vue&type=template&id=b38ad142&scoped=true&"
import script from "./AtDataTable.vue?vue&type=script&lang=js&"
export * from "./AtDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38ad142",
  null
  
)

export default component.exports